import { buildCandidateApplicationUrl } from "@workspace/dto/email/destinations";
import { z } from "zod";
import { buildFromAddress } from "../utils/build-email-address";
import {
  defineEmailNotificationHandler,
  requireOrganizationId,
  resolveWorkplaceName,
} from "./types";

const ApplicationDraftReminderSchema = z.object({
  applicationId: z.string(),
  jobTitle: z.string(),
  workplaceName: z.string(),
  stage: z.number().int().min(1).max(3),
});

export const applicationDraftReminderHandler = defineEmailNotificationHandler({
  type: "application.draft_reminder",
  icon: "application",
  title() {
    return "Finish your application";
  },
  description(metadata) {
    const title =
      typeof metadata.jobTitle === "string" ? metadata.jobTitle : "this job";
    return `Your application for ${title} is still in draft.`;
  },
  schema: ApplicationDraftReminderSchema,
  buildNotificationPayload(data) {
    return {
      metadata: data,
      links: {
        href: `/applications/${data.applicationId}`,
        label: "Continue application",
      },
      groupId: `draft-reminder:${data.applicationId}:${data.stage}`,
    };
  },
  buildEmailPayload(
    data,
    recipient,
    { baseUrl, organizationId, unsubscribeUrl }
  ) {
    return {
      name: "email/application.draft_reminder",
      data: {
        userId: recipient.userId,
        organizationId: requireOrganizationId({ organizationId }),
        to: recipient.email,
        from: buildFromAddress(),
        recipientName: recipient.name,
        jobTitle: data.jobTitle,
        workplaceName: resolveWorkplaceName(data.workplaceName),
        applicationUrl: buildCandidateApplicationUrl({
          applicationId: data.applicationId,
          baseUrl,
        }),
        stage: data.stage,
        unsubscribeUrl,
      },
    };
  },
});
